/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Shared header + route tabs for /projects, /projects/members and
// /projects/audit-log (redesign artboards 10, 23, 22).

import React from 'react';
import { PageHeader, Tabs } from '../console/ui';

interface ProjectsHeaderProps {
  subtitle: React.ReactNode;
  actions?: React.ReactNode;
  /** Number of projects (Overview tab badge). */
  projectCount?: number;
  /** Number of members in the selected project (Members tab badge). */
  memberCount?: number;
}

const ProjectsHeader: React.FC<ProjectsHeaderProps> = ({ subtitle, actions, projectCount, memberCount }) => (
  <>
    <PageHeader title="Projects" subtitle={subtitle} actions={actions} />
    <Tabs
      label="Project sections"
      tabs={[
        { label: 'Overview', to: '/projects', end: true, badge: projectCount || undefined },
        { label: 'Members', to: '/projects/members', badge: memberCount || undefined },
        { label: 'Audit log', to: '/projects/audit-log' },
      ]}
    />
  </>
);

export default ProjectsHeader;
